module.exports = __webpack_public_path__ + "static/media/Piazza blue.e47ad915.jpg";